import { useGraphQLQuery } from '@betterment/js-runtime';
import { CardLoader, ErrorBoundary } from '@betterment/shared-components';
import { useRequiredParam } from '@betterment/shared-components/src/hooks/useRequiredParam';

import FourOhOneKContributionsOverviewCard from '../../../FourOhOneKContributionsOverviewCard';
import { LegalAccountTaxationType } from '../../../graphql/schema';
import { PurposeSubAccountTypesDocument } from '../../graphql/purposeSubAccountTypes.generated';

export const FourOhOneKContributionsCard: React.FC = () => {
  const purposeId = useRequiredParam('purposeId');
  const { data } = useGraphQLQuery(PurposeSubAccountTypesDocument, { variables: { id: purposeId } });

  if (!data) return <CardLoader />;

  const subAccountTypes = data.purpose.envelope.legalSubAccounts.flatMap(sa => sa.legalAccount.taxationType);
  const four01kTypes = new Set([LegalAccountTaxationType.Roth_401K, LegalAccountTaxationType.Traditional_401K]);

  if (!subAccountTypes.some(t => four01kTypes.has(t))) return null;

  return (
    <ErrorBoundary fallbackType="none">
      <FourOhOneKContributionsOverviewCard />
    </ErrorBoundary>
  );
};
